export default __webpack_public_path__ + "static/media/image.spemai-pvt-ltd.2fae015e.png";